import useErrorHandledMutation from 'common/hooks/useErrorHandledMutation';

import { UpdateCreditCardStatusDocument } from './updateCreditCardStatus.gql';

export function useUpdateCreditCardStatusMutation() {
  return useErrorHandledMutation(UpdateCreditCardStatusDocument);
}
